<div id="main-content">
  <ng-content></ng-content>
</div>
